import { styled } from '@fluentui/utilities';
import { CheckboxBase } from './Checkbox.base';
import { getStyles } from './Checkbox.styles';
export var Checkbox = styled(CheckboxBase, getStyles, undefined, {
  scope: 'Checkbox'
});